var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizzazione_board",
    "data-name": "icona visualizzazione board",
    transform: "translate(-666 -99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_visualizzazione_board-2",
    "data-name": "icona visualizzazione board",
    transform: "translate(5292 -15980)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_241",
    "data-name": "Rettangolo 241",
    transform: "translate(-4626 16080)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 16,
    rx: 2.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 3.9,
    height: 15.4,
    rx: 1.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_242",
    "data-name": "Rettangolo 242",
    transform: "translate(-4621.5 16080)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 13.176,
    rx: 2.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 3.9,
    height: 12.576,
    rx: 1.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_243",
    "data-name": "Rettangolo 243",
    transform: "translate(-4617 16080)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 14.117,
    rx: 2.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 3.9,
    height: 13.517,
    rx: 1.95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_244",
    "data-name": "Rettangolo 244",
    transform: "translate(-4612.5 16080)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 9.412,
    rx: 2.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 3.9,
    height: 8.812,
    rx: 1.95,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_782",
    "data-name": "Rettangolo 782",
    transform: "translate(666 99)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBoard);
export default __webpack_public_path__ + "static/media/view_board.f5ff904a37eb890ead4fbc4ad7d8d097.svg";
export { ForwardRef as ReactComponent };